export default __webpack_public_path__ + "static/media/image-phone.901a66ee.webp";